import type { FC } from 'react';

import { useGetObligationById } from '@/hooks/queries';

type Props = {
  obligationId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ obligationId }) => {
  const { data } = useGetObligationById(obligationId!, !obligationId);

  return <>{data?.obligation?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
